export const SEARCH_PRODUCT_START = "SEARCH_PRODUCT_START"
export const SEARCH_PRODUCT_SUCCESS = "SEARCH_PRODUCT_SUCCESS"
export const SEARCH_PRODUCT_FAIL = "SEARCH_PRODUCT_FAIL"